<template>
  <div class="autocomplete mb-3">
    <b-input-group size="lg">
      <b-input-group-prepend>
          <b-button v-b-toggle.lastsearches variant="primary" :disabled="!this.lastSearches || this.lastSearches.length==0"> <v-icon name="clock" class="icon"></v-icon></b-button>
     </b-input-group-prepend>

      <vue-autosuggest
        ref="autocomplete"
        v-model="query"
        :suggestions="autocompleteTransformed"
        :inputProps="inputProps"
        :sectionConfigs="sectionConfigs"
        :getSuggestionValue="getSuggestionValue"
        :shouldRenderSuggestions="shouldRenderSuggestions"
        class="form-control"
        v-on:keyup.enter.prevent="onEnterClick"
      >

        <template slot-scope="{suggestion}">
        <span v-if="suggestion.name === 'autocomplete'" class="badge badge-secondary">{{suggestion.item.suggestion}}</span>

        <div v-else>
          <b-badge variant="success" class="mr-2" v-if="topicVisited(suggestion.item)">Visited</b-badge>

          <b-badge variant="info" class="" v-if="suggestion.item.action_statuses && suggestion.item.action_statuses.length > 0">{{suggestion.item.action_statuses[suggestion.item.action_statuses.length-1]}}</b-badge>

          <span class="suggtitle" v-if="suggestion.item.sem_title"> {{suggestion.item.sem_title | truncate(130, '...')}}</span><br>

          <span v-if="suggestion.item.id" class="badge badge-light"> {{suggestion.item.id}} </span>

          <span v-if="suggestion.item.callTitle" class="badge badge-light"> {{suggestion.item.callTitle}} </span>

        </div>

        </template>

        <template slot="before-section" >
          <div></div>
        </template>

      </vue-autosuggest>

      <b-input-group-append>
        <b-button v-if="query!=''" v-on:click.prevent="clearInput" variant="light" class="toolbuttons"><b-icon icon="x"></b-icon></b-button>

        <b-button v-on:click.prevent="saveSearch" variant="light" class="toolbuttons"><b-icon icon="bookmark-plus"  ></b-icon></b-button>

        <b-button v-on:click.prevent="openGraph" variant="primary">
          <b-icon icon="diagram-2" font-scale="1.3" variant="white"></b-icon> Graph
        </b-button>

        <b-button v-on:click.prevent="onEnterClick" variant="secondary"><b-icon icon="search" font-scale="1.3" variant="white"></b-icon>{{$t('general.search')}}</b-button>
      </b-input-group-append>


    </b-input-group>
<!--
    <b-modal size="xl" id="prefetched_modal" ref="prefetched_modal"
      ok-only ok-title="Close">

        <h2 v-if="this.selected && this.selected.sem_record_type=='topic'">
          <b-badge variant="success" class="mr-2" v-if="topicVisited">Visited</b-badge>
          <b-badge variant="light" class="" v-if="this.selected.sem_source_id">{{this.selected.sem_source_id}}</b-badge>
          {{this.selected.sem_title}}
          <a v-on:click.prevent="openGraphByNodeId()" href="#">
            <b-icon icon="diagram-2" font-scale="2" variant="secondary"></b-icon>
          </a>
        </h2>

        <b-tabs card>
          <ResultTopic v-if="this.selected && this.selected.sem_record_type=='topic'" v-bind:result="this.selected"></ResultTopic>

          <ExtractedInformation v-if="this.selected" v-bind:result="this.selected"></ExtractedInformation>

          <MoreLikeThis v-if="this.selected" v-bind:url="this.selected.sem_actions.mlt.sem_url"></MoreLikeThis>

        </b-tabs>
    </b-modal> -->
    <LastSearches></LastSearches>

  </div>
</template>

<script>
import LastSearches from './LastSearches'

window.$ = require('jquery');

export default {
  name: "autocomplete",
  components: {
    LastSearches,
  },
  data() {
    return {
      query: "",
      results: [],
      autocompleteTransformed: [],
      timeout: null,
      selected: null,
      debounceMilliseconds: 250,
      inputProps: {
        id: "autosuggest__input",
        placeholder: "",
      },
      sectionConfigs: {
        'default': {
          limit: 1,
          onSelected: function() {
              // nothing to do
          }
        },
        autocomplete: {
          limit: 6,
          label: "",
          onSelected: selected => {

            this.selected = selected.item;
            this.query = this.selected.suggestion;

            if( this.$store.state.preserveFilters ) {
              var action = this.searchWithCurrentState + '&q=' + this.selected.suggestion;
              this.$router.push(action);
            } else {
              this.$router.push(this.selected.sem_action.sem_url_action);
            }

            Object.assign(this.$route.params, {'ls': true});

            this.selected = null;
          }
        }
      }
    };
  },
  created: function () {
    if( this.$router.currentRoute.query && this.$router.currentRoute.query.q != undefined && this.$router.currentRoute.query.q != '') {
      this.query = this.$router.currentRoute.query.q;
    }
  },
  computed: {
    pageContent () {
        return this.$store.state.page;
    },
    pageId () {
        return this.$store.state.pageId;
    },
    prefetchedResults() {
      if (this.$store.state &&
        this.$store.state.suggest &&
        this.$store.state.suggest.response &&
        this.$store.state.suggest.response.prefetchedResults &&
        this.$store.state.suggest.response.prefetchedResults.response &&
        this.$store.state.suggest.response.prefetchedResults.response.docs) {
        return this.$store.state.suggest.response.prefetchedResults;
      }

      return null;
    },
    autocomplete () {
      if (this.$store.state &&
          this.$store.state.suggest &&
          this.$store.state.suggest.response &&
          this.$store.state.suggest.response.autocomplete ) {

          return this.$store.state.suggest.response.autocomplete;
      }

      return null;
    },
    terms() {
      if (this.$store.state &&
          this.$store.state.suggest &&
          this.$store.state.suggest.response &&
          this.$store.state.suggest.response.prefetchedResults &&
          this.$store.state.suggest.response.prefetchedResults.context &&
          this.$store.state.suggest.response.prefetchedResults.context.originalSearchTerms ) {

        return this.$store.state.suggest.response.prefetchedResults.context.originalSearchTerms
      } else {
        return '';
      }
    },
    savedSearchDescription() {
      var ret = '';

      if (this.$store.state.response &&
        this.$store.state.response.active_filters &&
        this.$store.state.response.active_filters.filters && this.$store.state.response.active_filters.filters.length != 0) {
        ret += this.$store.state.response.active_filters.filters.length + ' filters active: ';

        for( var i=0; i<this.$store.state.response.active_filters.filters.length; i++) {
          ret += '[' + this.$store.state.response.active_filters.filters[i].componentName + ': ' + this.$store.state.response.active_filters.filters[i].valueLabel + '] '
        }
      }

      return ret;
    },
    lastSearches () {
      if (this.$store.state.lastSearches ) {
        return this.$store.state.lastSearches;
      } else {
        return '';
      }
    },
    fullQuery() {
      if (this.$store.state.response &&
        this.$store.state.response.base_urls &&
        this.$store.state.response.base_urls.search_with_current_state) {

        if( this.query.trim() != '' ) {
          return this.$store.state.response.base_urls.search_with_current_state.sem_url_action + '&q=' + this.query.trim();
        } else {
          return this.$store.state.response.base_urls.search_with_current_state.sem_url_action + '&q=*';
        }
      }
      return null;
    },
    searchWithCurrentState() {
      if (this.$store.state.response &&
        this.$store.state.response.base_urls &&
        this.$store.state.response.base_urls.search_with_current_state) {
          return this.$store.state.response.base_urls.search_with_current_state.sem_url_action;
      }
      return null;
    }
  },
  methods: {
    clearInput () {
      this.query = '';
      this.selected = null;
    },
    openGraph () {
      if(this.query && this.query != '') {
        this.$router.push({ name: 'visualization', query: { q: this.query } })
      } else {
        this.$router.push({ name: 'visualization', query: { q: '*' } })
      }
    },
    openGraphByNodeId () {
       this.$router.push({ name: 'visualization', query: { id: this.selected.id }, params: { nodeTitle: this.selected.sem_title } })
    },
    getSuggestionValue(suggestion) {
      let { name } = suggestion;
      if (name == "autocomplete") {
        return suggestion.item.suggestion;
      } else {
        this.query = this.$store.state.suggest.response.prefetchedResults.term
        return this.$store.state.suggest.response.prefetchedResults.term;
      }
    },
    shouldRenderSuggestions (size, loading) {
      return size >= 0 && !loading && this.query
    },
    onEnterClick () {
      if( this.$store.state.preserveFilters && this.searchWithCurrentState ) {
        var action = this.searchWithCurrentState + '&q=';
        if(this.query.trim() == '') {
          action += '*';
        } else {
          action += this.query;
        }
        this.$router.push(action);
      } else {
        if(this.query.trim() == '') {
          this.$router.push({ query: { }, params: {'ls': true} });
        } else {
          this.$router.push({ query: { q: this.query },params: { 'ls': true} });
        }
      }



    },
    topicVisited (item) {
      if (this.$store.state.visitedTopics ) {
        return this.$store.state.visitedTopics.indexOf(item.id) > -1;
      } else {
        return false;
      }
    },
    saveSearch () {
      var searchToSave = {
        "id": "",
        "name": '*',
        "query": '*',
        "description": this.savedSearchDescription,
        "frequency": "NONE"
      };

      if( this.query.trim() != '' ) {
        searchToSave.name = this.query.trim();
      }

      if( this.fullQuery ) {
        searchToSave.query = this.fullQuery;
      }

      this.$toast.open({
        message: "Your search has been saved. You can change settings in the Saved area.",
        type: "default",
        position: "bottom-right",
        duration: 5000,
      });

      this.$store.dispatch('saveSearch', { 'searchToSave': searchToSave });
    }
  },
  watch: {
    query: function (v) {
      if (v && v.trim().length > 2) {
        return this.$store.dispatch('fetchLatestSuggestions', v);
      }
    },
    $route (to){
      if(to.query && to.query.q ) {
        this.query = to.query.q;
      } else {
        this.query = '';
      }
    },
    autocomplete: function( newAutocomplete) {

      var ret = [];

      if ( newAutocomplete ) {
          ret.push({ name: "autocomplete", data: newAutocomplete.suggestions });
      }

      if ( this.prefetchedResults ) {

          var group = this.prefetchedResults.response.docs;
          var groupvalue = "Topics";

          this.sectionConfigs[groupvalue] = {
              limit: 20,
              label: groupvalue,
              onSelected: selected => {
                this.selected = selected.item;
                this.query = this.prefetchedResults.term;

                this.$router.push({ path: '/detail/' +  this.selected.id});
              }
          };

          ret.push({ name: groupvalue, data: group });

      }

      this.autocompleteTransformed = ret;
    }

  },
  filters: {
    truncate: function (text, length, suffix) {
      if( text.length > length )
        return text.substring(0, length) + suffix;
      else
        return text;
    }
  }
};
</script>

<style>
.autocomplete .icon {
  width: 20px;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  -webkit-box-shadow: 5px 5px 5px rgba(0,0,0,0.3) !important;
  -moz-box-shadow: 5px 5px 5px rgba(0,0,0,0.3) !important;
  box-shadow: 5px 5px 5px rgba(0,0,0,0.3) !important;
  background: white;
  padding: 0px;
  max-height: 725px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 10px 15px 10px 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  //font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;

  font-weight: 900;
  font-size: 16px;
  color: #05345d;
  text-transform: uppercase;
  //border-bottom: 5px solid #05345d;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}

.autosuggest__results .autosuggest__results-item {
  color: #05345d;
  font-weight: 500;
  font-size: 0.9rem;

}

#autosuggest__input {
  border: none;
  width: 100%;
  margin: 6px;
  max-width: 100%;
  background-color: transparent;
}
#autosuggest__input:focus {
  outline: none;
}
#autosuggest {
  padding: 0px;
}

.autocomplete .badge{
  margin: 0px 2px;
  vertical-align: middle;
  padding: 4px 4px 3px 4px;
}
.autocomplete .suggtitle{
  margin-right: 4px;
}
.autosuggest__results ul:first-child li {
  float: left;
}
.autosuggest__results ul {
  clear: both;
}
.toolbuttons {
  border: 1px solid #ced4da;
  background-color: #fff;
}
.autosuggest__results-before--f1, .autosuggest__results-before--f0 {
  display:none;
}

</style>
